

export function getAuthToken() {
  const token = localStorage.getItem('tokenAdmin');
  // console.log('token: '+token)
  return token;
}


export function checkContainsToken() {
  const token = getAuthToken();

  if (!token) {
    console.log("no tiene token" + token)
  }

}